import en from './locale/en'
import de from './locale/de'
import nl from './locale/nl'
import pt from './locale/pt'
import es from './locale/es'
import fr from './locale/fr'
import cs from './locale/cs'
import { LOCALE_CODES } from '../app/root/constants'

export default function getLocale(code) {
    let locale
    switch (code) {
        case LOCALE_CODES.en:
            locale = en
            break
        case LOCALE_CODES.de:
            locale = de
            break
        case LOCALE_CODES.nl:
            locale = nl
            break
        case LOCALE_CODES.pt:
            locale = pt
            break
        case LOCALE_CODES.es:
            locale = es
            break
        case LOCALE_CODES.fr:
            locale = fr
            break
        case LOCALE_CODES.cs:
            locale = cs
            break
        default:
            locale = de
            break
    }
    return locale
}
